import { Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { FabricationMethod } from '../../core/model/fabrication-method';
import { RxHelper } from '../../core/utils/rxjxHelper';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FabricationMethodOptions } from '../../core/constants/options/fabrication-method-options';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'app-fabrication-methods-select',
    standalone: true,
    imports: [CommonModule, RadioButtonModule, FormsModule],
    templateUrl: './fabrication-methods-select.component.html',
    styleUrls: ['./fabrication-methods-select.component.scss'],
    providers: [
        RxHelper,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FabricationMethodsSelectComponent),
            multi: true,
        },
    ],
})
export class FabricationMethodsSelectComponent implements OnInit, ControlValueAccessor {
    @Input() showNone = true;
    @Input() isDisabled = false;

    private readonly _rxHelper = inject(RxHelper);

    protected readonly options = [...FabricationMethodOptions];
    protected readonly selectionModel = new SelectionModel<FabricationMethod | null>(false);
    protected onChangeFn?: (value: FabricationMethod | null) => unknown;
    protected onTouchedFn?: () => unknown;

    ngOnInit() {
        this.selectionModel.changed.pipe(this._rxHelper.autoUnsubscribe).subscribe(() => {
            this.onChangeFn?.(this.selectionModel.selected[0]);
        });
        this.selectionModel.select(null);
    }

    writeValue(obj: unknown): void {
        if (typeof obj === 'number') {
            this.selectionModel.select(obj);
        } else {
            this.selectionModel.select(null);
        }
    }

    registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }
}
